module.exports = __webpack_public_path__ + "media/images/sp/specials/common/special_c_06-93283bd9ae71b9aebc00e0ea41398ccd.jpg";